import React from "react"
import BrandVoice from "../brand-voice"

const About = () => (
  <BrandVoice
    title="Hardhat is now part of Thinkerbell"
    introText="In 2024, Hardhat officially joined Thinkerbell, bringing our customer experience and behaviour change expertise into the world of Measured&nbsp;Magic.&nbsp;
    <br /><br />After nearly two decades delivering creative brand-led business transformation, the Hardhat name has been retired."
    timelineItems={[
      {
        text:
          "Founded at the dawn of 'digital' in 2005, we get what makes people tick, click, swipe, buy and believe.",
      },
      {
        text:
          "As times, trends and technologies have changed, so have we, growing to become one of Australia's most innovative full-service agencies.",
      },
      {
        text: "",
      },
    ]}
  />
)

export default About
